module.exports = __webpack_public_path__ + "media/images/logo-9930c01a82f516d3ebedd99eebd6d0dd.png";